import React, { useState, useEffect, useRef } from "react";
import { Link, Redirect } from "react-router-dom";
import { openModal, closeModal } from "@redq/reuse-modal";
import ProductCard from "../../components/ProductCard/ProductCard";
import AuthenticationForm from "../../containers/SignInOutForm/Form";
import { AuthContext } from "../../contexts/auth/auth.context";
import { SearchContext } from "../../contexts/search/search.context";
import { useCart } from "../../contexts/cart/use-cart";
import {
  ProductsRow,
  ProductsCol,
  ButtonWrapper,
  LoaderWrapper,
  LoaderItem,
  ProductCardWrapper,
  FilterWrapper,
  FilterDiv,
  FilterModalWrapper,
  BrandName,
  BrandInfo,
  BrandImageWrapper,
  PromoWrapper,
  PromoTitle,
  NewArrivalTitle,
  Wrapper,
  Prev,
  Next,
  BoxTitle,
  ErrorModal,
  ViewAll,
  ProductTopTitle
} from "./Products.style";
import { CURRENCY } from "../../helper/constant";
import { useLocation, useHistory,useParams } from "react-router-dom";
import Button from "../../components/Button/Button";
import Checkbox from "../../components/Checkbox/Checkbox";
import Fade from "react-reveal/Fade";
import NoResultFound from "../../components/NoResult/NoResult";
import QuickView from "../QuickView/QuickView";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Placeholder from "../../components/Placeholder/Placeholder";
import { Modal, Spinner } from "react-bootstrap";
import Switch from "react-switch";
import DropDown from "../../components/DropDown";
import BrandFilter from "../../components/BrandFilter";
import Carousel from "react-multi-carousel";
import { BrandButton } from "../../components/BrandFilter/BrandFilter.style";
import Loader from "../../components/Loader/Loader";
import { SearchBox } from "../../components/SearchBox/SearchBox.style";
import PageLoader from "../../components/PageLoader/PageLoader";
import _ from "lodash";
import { cats } from "../../helper/constant";
import LazyLoad from "react-lazyload";
import { ArrowNext, ArrowPrev } from "../../components/AllSvgIcon";
import {getCookie, setCookie} from "../../helper/constant";
import expressService from "../../services/expressService";
import t from '../../i18n/translate';
import SidebarFilter from "../../components/SideBarFilter/SideBarfilter";
import defaultBrandLogo from "../../assets/icons/delishop_logo2.svg";
import {logPageView,logViewItem} from "../../services/googleAnalytics"
const animatedComponents = makeAnimated();

export const Products = ({
  deviceType,
  type,
  // ptype = "usual",
  fetchLimit = 50,
  loadMore = true,
  props,
  storeId,
  textSearch,
  isExtra,
  brandName,
  isFilterModal,
  toggleFilter,
  isCloseSEO = false,
  onSeenProduct = null,
}) => {
  
  const { isloading, disableloading,updateItem } = useCart();
  //   // Quick View Modal
  const [show, setShow] = useState(false);
  const [isBrandFilter, setBrandFilter] = useState(false);
  const [checked, setChecked] = useState(false);
  const [selected, setSelected] = useState([]);
	const [selectedCat, setSelectedCat] = useState([]);
	const [selectedDiet, setSelectedDiet] = useState([]);
  const [selectedSubCat, setSelectedSubCat] = useState([]);
  const [cat_name, setCat_name, search_text] = useState("");
  const [sub_cat_name, setSubCat_name] = useState("");
  const [filterShow, setFilterShow] = useState(false);
  const [brandname, setBrandName] = useState("");
  const [brandinfo, setBrandInfo] = useState("");
  const [loader, setLoader] = useState(false);
  const [bvalues, setBValues] = useState([]);
  const [catvalues, setCatValues] = useState([]);
  const [subCatvalues, setSubCatValues] = useState([]);
  const [showbwpopup, setShowBWPopup] = useState(true);
  const [itemCategory, setItemCategory] = useState([]);
  const [allCategory, setAllCategory] = useState([]);
  const [showFilterNotFound, setShowFilterNotFound] = useState(false);
  ///////////// brand filter modal //////////////
  const [isBrandSelected, setBrandSelected] = useState({});
  const [isCatSelected, setCatSelected] = useState({});
  const [isSubCatSelected, setSubCatSelected] = useState({});

  const SUB_CAT_ID = localStorage.getItem("sub_cat_id");
  const CAT_ID = localStorage.getItem("cat_id");
  const onHide = () => setShow(false);
  const onClose = () => setBrandFilter(false);
  const onOpen = () => setBrandFilter(true);
  const filterOnHide = () => setFilterShow(false);
  const [isOutOfStock, setIsOutOfStock] = useState(0);
  const [brandId, setBrandId] = useState([]);
  const [min, setMin] = useState(0);
  const [check, setCheck] = useState(0)
  const [isFilter,setIsFilter] = useState(null)
  const [max, setMax] = useState(0);
  const [catId, setCatId] = useState([]);
  const [sort, setSort] = useState('');
  const lang = localStorage.getItem('lang') || 'en';
  const [displayExpressMultiLabel, setDisplayExpressMultiLabel] = useState(false);

  const {
    authState: { isAuthenticated },
    authDispatch,
  } = React.useContext(AuthContext);
  const { state, searchdispatch } = React.useContext(SearchContext);
  const [showform, setShowForm] = useState(false);
  const handleJoin = () => {
    authDispatch({
      type: "SIGNIN",
    });
    setShowForm(true);
  };

  
  const itemsRefs = useRef({});

  useEffect(() => {
      if (!props.products.length) return;
      // const idsOnly = props.products.map(product => product.item_id)
      // const jsonIds = JSON.stringify(idsOnly)
      // localStorage.setItem("viewProductListCategory", jsonIds)

      const observer = new IntersectionObserver(
      (entries) => {
          entries.forEach(entry => {
              if (entry.isIntersecting) {
                const id = entry.target.dataset.id;
                if (onSeenProduct) {
                  onSeenProduct(id);
                }
                observer.unobserve(entry.target);
              }
          });
      },{
          root: null,
          rootMargin: "0px",
          threshold: 0
      }
      );

      Object.values(itemsRefs.current).forEach(node => {
      if (node) observer.observe(node);
      });

      return () => observer.disconnect();
  }, [props.products, onSeenProduct]);

  // const openFilterMOdal = () => {
  //   setShowFilter(!showFilter)
  // }
  const handleQuickViewModal = (modalProps, deviceType, index) => {
    props.ProductModalData(modalProps);

    setShow(true);
    trackClick(modalProps, index);
    trackDetails(modalProps, index);
  };
  const trackClick = (item, index) => {
    //track click
    // window.analytics && window.analytics.track("Product Clicked", {
    //   product_id: item.item_id,
    //   sku: item.product_code,
    //   category: item.cat_id,
    //   name: item.name,
    //   brand:
    //     item.list_brands &&
    //     item.list_brands[0] &&
    //     item.list_brands[0].brand_name
    //       ? item.list_brands[0].brand_name
    //       : "",
    //   variant: item.name,
    //   price: item.store_items_price_types[0].price,
    //   quantity: 1,
    //   position: index + 1,
    // });
  };
  const trackDetails = (item, index) => {
    //track click
    // window.analytics && window.analytics.track("Product Viewed", {
    //   product_id: item.item_id,
    //   sku: item.product_code,
    //   category: item.cat_id,
    //   name: item.name,
    //   brand:
    //     item.list_brands &&
    //     item.list_brands[0] &&
    //     item.list_brands[0].brand_name
    //       ? item.list_brands[0].brand_name
    //       : "",
    //   variant: item.name,
    //   price: item.store_items_price_types[0].price,
    //   quantity: 1,
    //   position: index + 1,
    //   currency: "USD",
    //   value: item.store_items_price_types[0].price,
    // });
  };
  const trackPromotionClick = (item, index) => {
    //track click
    // window.analytics && window.analytics.track("Promotion Clicked", {
    //   promotion_id: item.item_id,
    //   creative: "",
    //   name: item.name,
    //   position: index + 1,
    // });
  };
  let { pathname, search } = useLocation();
  let history = useHistory();
  const location = useLocation();
  let { catrefid, subcatrefid, text } = useParams();
  const Params = new URLSearchParams(location.search);
  const [queryFilter,setQueryFilter] = useState({})
  // Remove the leading '?' from the search string
  const queryString = search.startsWith('?') ? search.slice(1) : search;
  const getSearchQuery = async () => {
    let isSubCat = 0;
    let isCat = 0;
    // Convert searchParams to an object

    if (!!(Params && search) && !!!(window.location.pathname.split("/")[1] === "search")){
      props.category.map((element, index) => {
        if (element.cat_ref_id == catrefid) {
          isCat = 1;
          element.map_categories_sub_cats.map((sub_cat, idx1) => {
            sub_cat.list_sub_categories.map((sub_name, idx2) => {
              if (sub_name.sub_cat_ref_id == subcatrefid) {
                isSubCat = 1;
                // if (!window.location.pathname.split("/")[1] === "search"){
                  localStorage.setItem("sub_cat_id", sub_name.sub_cat_id);
                  localStorage.setItem("subcatname", sub_name.name);
                // }
              }
            });
          });
        }
      });
      const paramsObject = {};
      const catId = Params.get("cat_id")?.split(",");
      const subCatId = Params.get("sub_cat_id")?.split(",");
      const brandId = Params.get("brand_id")?.split(",");
      const oos = Params.get("oos");
      const min = Params.get("min");
      const max = Params.get("max");
      const isFilter = Params.get("isFilter");
      const priority = Params.get("priority");
	    const promotion = Params.get("promotion");
	    const dietId = Params.get("diet_id")?.split(",");
      const sort = Params.get("sort");
      const countryId = Params.get("country_id")?.split(",");
      let allSelected = [];
      if (brandId && (brandId?.length > 0) && brandId[0] !== "") {
        let brand = brandId?.map((i) => ({
          value: Number(i),
          label: i,
        }));
        allSelected.brands = [...brand];
      } else {
        allSelected.brands = [];
      }
      if (catId && catId?.length > 0 && catId[0] !== "") {
        let cat = catId?.map((i) => ({
          value: Number(i),
          label: i,
        }));
        allSelected.category = [...cat];
      } else {
        allSelected.category = [];
      }

	    if (dietId && dietId?.length > 0 && dietId[0] !== "") {
		    let diet = dietId?.map((i) => ({
			    value: Number(i),
			    label: i,
		    }));
		    allSelected.dietary = [...diet];
	    } else {
		    allSelected.dietary = [];
	    }

      if (subCatId && (subCatId?.length > 0) && subCatId[0] !== "") {
        let sub_cat = subCatId?.map((i) => ({
          value: Number(i),
          label: i,
        }));
        allSelected.sub_category = [...sub_cat];
      } else {
        allSelected.sub_category = [];
      }

      if (countryId && (countryId?.length > 0) && countryId[0] !== "") {
        let country = countryId?.map((i) => Number(i));
        allSelected.country_id = [...country];
      } else {
        allSelected.country_id = [];
      }
      allSelected.min = min || 0;
      allSelected.max = max || 1000;
      allSelected.isFilter = true;
      allSelected.priority = priority || 0;
      allSelected.promotion = promotion || false;
      allSelected.sort = sort && sort != "undefined" && sort != "null" ? sort : "";
      allSelected.check = false;
      if (!!!(Params && search) && window.location.pathname.split("/")[1] === "search") {
        localStorage.setItem("sub_cat_id", -1);
        localStorage.setItem("subcatname", "");
        localStorage.setItem("mode", "search");
        localStorage.setItem("cat_id", 0);
      }
      await props.getProductFilterBrands(
        allSelected,
        props.products,
        props.allproducts,
        SUB_CAT_ID,
        localStorage.getItem("cat_id"),
        brandName,
        props.oos,
        state.text
      );

      let newCountry = [];
      if (countryId && countryId?.length > 0 && countryId[0] !== "") {
        let item = countryId?.map((i) => ({
          value: Number(i),
          label: i,
        }));
        newCountry = [...item];
      } else {
        newCountry = [];
      }
      setQueryFilter({
        ...allSelected,
        brand_id: allSelected.brands["brand_id"],
        cat_id: allSelected.category["cat_id"],
        sub_cat_id: allSelected.sub_category["sub_cat_id"],
	      country_id: newCountry || [],
	      diet_id: allSelected.dietary || [],
      });
    }
    else if ((props.category.length > 0 && window.location.pathname.split("/")[1] === "search") && !!(Params && search)){
      const paramsObject = {};
      const catId = Params.get("cat_id")?.split(",");
      const subCatId = Params.get("sub_cat_id")?.split(",");
      const brandId = Params.get("brand_id")?.split(",");
      const oos = Params.get("oos");
      const min = Params.get("min");
      const max = Params.get("max");
      const isFilter = Params.get("isFilter");
      const priority = Params.get("priority");
      const promotion = Params.get("promotion");
	    const dietId = Params.get("diet_id")?.split(",");
	    const sort = Params.get("sort");
      const countryId = Params.get("country_id")?.split(",");
      let allSelected = [];
      if (brandId && (brandId?.length > 0) && brandId[0] !== "") {
        let brand = brandId?.map((i) => ({
          value: Number(i),
          label: i,
        }));
        allSelected.brands = [...brand];
      } else {
        allSelected.brands = [];
      }
      if (catId && catId?.length > 0 && catId[0] !== "") {
        let cat = catId?.map((i) => ({
          value: Number(i),
          label: i,
        }));
        allSelected.category = [...cat];
      } else {
        allSelected.category = [];
      }

	    if (dietId && dietId?.length > 0 && dietId[0] !== "") {
		    let diet = dietId?.map((i) => ({
			    value: Number(i),
			    label: i,
		    }));
		    allSelected.dietary = [...diet];
	    } else {
		    allSelected.dietary = [];
	    }

      if (subCatId && (subCatId?.length > 0) && subCatId[0] !== "") {
        let sub_cat = subCatId?.map((i) => ({
          value: Number(i),
          label: i,
        }));
        allSelected.sub_category = [...sub_cat];
      } else {
        allSelected.sub_category = [];
      }

      if (countryId && (countryId?.length > 0) && countryId[0] !== "") {
        let country = countryId?.map((i) => Number(i));
        allSelected.country_id = [...country];
      } else {
        allSelected.country_id = [];
      }
      allSelected.min = min || 0;
      allSelected.max = max || 1000;
      allSelected.isFilter = true;
      allSelected.priority = priority || 0;
      allSelected.promotion = promotion || false;
      allSelected.sort = sort && sort != "undefined" && sort != "null" ? sort : "";
      allSelected.check = false;
        localStorage.setItem("sub_cat_id", -1);
        localStorage.setItem("subcatname", "");
        localStorage.setItem("mode", "search");
      await props.getProductFilterBrands(
        allSelected,
        props.products,
        props.allproducts,
        ["search"].includes(window.location.pathname.split('/')[1]) ? -1 : SUB_CAT_ID,
        localStorage.getItem("cat_id"),
        brandName,
        props.oos,
        state.text
      );

      let newCountry = [];
      if (countryId && countryId?.length > 0 && countryId[0] !== "") {
        let item = countryId?.map((i) => ({
          value: Number(i),
          label: i,
        }));
        newCountry = [...item];
      } else {
        newCountry = [];
      }
      setQueryFilter({
        ...allSelected,
        brand_id: allSelected.brands["brand_id"],
        cat_id: allSelected.category["cat_id"],
        sub_cat_id: allSelected.sub_category["sub_cat_id"],
        country_id: newCountry || [],
	      diet_id: allSelected.dietary || [],
      });
    }
  };
  useEffect(() => {
    getSearchQuery();
  }, [SUB_CAT_ID]);

  const freezeClicFn = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const isInViewport = () => {
    let screenWidth = 1200;
    if(window.screen.width  < 800){
      screenWidth = 1000;
    }
    if (
      (window.innerHeight + window.scrollY >= document.body.offsetHeight - screenWidth && props.page >= 1) && props.isHasMore
    ) {
      // User has scrolled to the bottom, load more products
      if(document.getElementById("showMore")){
        setLoader(true);
        document.getElementById("showMore").click();
        handleLoadmore()
      }else{
        setLoader(false);
      }
    }else {
      setLoader(false);
    }
    // const wrappedElement = document.getElementById('productList');
    // if (wrappedElement && wrappedElement.getBoundingClientRect().bottom <= window.innerHeight && props.page >= 1) {
      // if(document.getElementById("showMore")){
      //   setLoader(true);
      //   document.getElementById("showMore").click();
      // }
  };
  const handleLoadmore = () => {
    console.log(props.loading);
    if(props.loading){
      return;
    }
    else if(props.isHasMore && props.products.length !== 0 && props.loading == false && loader){
      props.changePage({page:props.page+1}); 
    }
    setLoader(false);
  }

  useEffect(() => {
    document.addEventListener("scroll", isInViewport);
    return () => {
      document.removeEventListener("scroll", isInViewport);
    };
  },[]);

  useEffect(() => {
    if (isloading) {
      document.getElementById("root").classList.add("loading");
    } else {
      document.getElementById("root").classList.remove("loading");
    }
  }, [isloading]);
  useEffect(() => {
    if(props.oos === 0 || !props.oos) {
      setChecked(false);
    }
    else {
      setChecked(true);
    }
  }, [props.oos]);

  useEffect(() => {
    if (isAuthenticated) {
      setShowForm(false);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (props.brands.length > 0) {
      for (let i = 0; i < props.brands.length; i++) {
        if(window.location.pathname.split("/")[1] === "brand" && window.location.pathname.split("/")[2] === props.brands[i]["brand_ref_id"]){
          setBrandName(props.brands[i]["name"] !== null ? props.brands[i]["name"] : "");
          setBrandInfo(props.brands[i]["description"] !== null ? props.brands[i]["description"] : "" );
          document.title = props.brands[i]["name"];
        }
        props.brands[i].label = props.brands[i]["name"];
        props.brands[i].value = props.brands[i]["brand_id"];
      }
    }
  }, [props.brands]);

  useEffect(() => {
    const selector = document.getElementById('isExtraData');

    if(selector === null) {
      setDisplayExpressMultiLabel(false);
    }
    else if(selector && !displayExpressMultiLabel) {
      createExtraLabel(selector);
    }
    else if(!document.querySelector('.clearFlex') && selector) {
      createExtraLabel(selector);
    }
  })

  const createExtraLabel = (selector, ) => {
    setDisplayExpressMultiLabel(true);
    let container = document.createElement("div"); // Create div tag
    container.classList.add('clearFlex'); // Assign clearFlex class to div tag
    let span = document.createElement("span"); // Create span tag
    span.textContent = t('shop_extra_supplier_item_title'); // Add localize text into span tag
    container.appendChild(span); // Add span tag into div tag
    selector.parentNode.insertBefore(container, selector); // Do insert before
  };

  const bannerPickers = () =>{
    let banner_image= "gg"
    if(parseInt( localStorage.getItem("sub_cat_id")) != 0 && localStorage.getItem("sub_cat_id") ){
      props.category.forEach(element => {
        element.map_categories_sub_cats.forEach(e => {
          
          if( e.list_sub_categories[0].sub_cat_id == parseInt(localStorage.getItem("sub_cat_id")) ) banner_image = e.list_sub_categories[0].banner_image
        }); 
      });
    }else if(localStorage.getItem("cat_id")){
      props.category.forEach(e => {
        if(e.cat_id == parseInt(localStorage.getItem("cat_id")) ) banner_image = e.banner_image;
      })
    }
   // return banner_image;
    if(banner_image && banner_image !== 'gg') {
      return <img src={banner_image} alt="Delishop banner" width={"100%"} height={"auto"} style={{margin: "20px auto"}} />
    }
  }
  const GetSub = () => {
    if (!((cats).includes(window.location.pathname.split("/")[1]) && window.location.pathname.split("/").length === 2)) {
      // localStorage.setItem("mode", "subcatoos");
      localStorage.setItem("sub_cat_id", window.location.pathname === "/" || window.location.pathname === "/best-deals/promotions" ? 187 : (localStorage.getItem("sub_cat_id") ? localStorage.getItem("sub_cat_id") : props.products[0]?.sub_cat_id));
      // props.resetPage();
      // props.getProductOutOfStock({
      //   sub_cat_id: window.location.pathname === "/" ? 187 : localStorage.getItem("sub_cat_id"),
      //   store_id: 1,
      //   oos: 1,
      //   page: 1
      // });
    }
  }

  const toggleCheckbox = async () => {
    setFilterShow(false);
    let filteredProducts = {brandIdList: [], categorySelected: [], subCategorySelected: [], outOfStock: 0, search: '', sort: ''};
    if(!Array.isArray(props.filteredProducts) && Object.keys(props.filteredProducts).length) {
      filteredProducts.brandIdList = props.filteredProducts.brandIdList;
      filteredProducts.categorySelected = props.filteredProducts.categorySelected;
      filteredProducts.subCategorySelected = props.filteredProducts.subCategorySelected;
      filteredProducts.search = props.filteredProducts.search;
      filteredProducts.sort = props.filteredProducts.sort;
    }

    if (!checked === true) {
      setChecked(true);
      setIsOutOfStock(1);
      props.oosModified({status: true});

      if(props.cartType === 'express') {
        filteredProducts.outOfStock = 1;
        const itemsStore = await expressService.storeItems(
          [storeId],
          filteredProducts.brandIdList,
          filteredProducts.categorySelected,
          filteredProducts.subCategorySelected,
          1,
          filteredProducts.search,
        );
        props.initProductExpressStore(itemsStore.list);
        props.sortProducts(filteredProducts);
      }
      else {
        if (window.location.pathname.split("/").length === 3){
          localStorage.setItem("mode","subcatoos");
          localStorage.setItem("sub_cat_id", window.location.pathname === "/" || window.location.pathname === "/best-deals/promotions" ? 187 : (localStorage.getItem("sub_cat_id") ? localStorage.getItem("sub_cat_id") : props.products[0].sub_cat_id));
          props.resetPage();
          props.getProductOutOfStock({
            sub_cat_id: window.location.pathname === "/" ? 187 : localStorage.getItem("sub_cat_id"),
            store_id: 1,
            oos: 1,
            page: 1
          });
        }
        else{
          localStorage.setItem("mode","catoos");
          localStorage.setItem("cat_id", window.location.pathname === "/" || window.location.pathname === "/best-deals" ? 18 : props.products[0].cat_id);
          props.resetPage();
          props.getProductOutOfStockCat({
            cat_id:
              window.location.pathname === "/" || window.location.pathname === "/best-deals"
                ? 18
                : props.products[0].cat_id,
            store_id: 1,
            oos: 1,
            page: 1
          });
        }
      }
    }
    else {
      setChecked(false);
      setIsOutOfStock(0);
      props.oosModified({status: false});

      if(props.cartType === 'express') {
        filteredProducts.outOfStock = 0;
        const itemsStore = await expressService.storeItems(
          [storeId],
          filteredProducts.brandIdList,
          filteredProducts.categorySelected,
          filteredProducts.subCategorySelected,
          0,
          filteredProducts.search,
        );
        props.initProductExpressStore(itemsStore.list);
        props.sortProducts(filteredProducts);
      }
      else {
        if (window.location.pathname.split("/").length === 3) {
          localStorage.setItem("sub_cat_id", window.location.pathname === "/" ? 187 : (localStorage.getItem("sub_cat_id") ? localStorage.getItem("sub_cat_id") : props.products[0].sub_cat_id));
          localStorage.setItem("mode","subcat");
          props.resetPage();
          props.getProductsMappedwithSubCat({
            sub_cat_id: window.location.pathname === "/" ? 187 : localStorage.getItem("sub_cat_id"),
            store_id: 1,
            page: 1,
            lang
          });
        }
        else {
          localStorage.setItem("cat_id", window.location.pathname === "/" || window.location.pathname === "/best-deals" ? 18 : props.products[0].cat_id);
          localStorage.setItem("mode","cat");
          props.resetPage();
          props.getProductsMappedwithCat({
            cat_id:
              window.location.pathname === "/" || window.location.pathname === "/best-deals"
                ? 18
                : props.products[0].cat_id,
            store_id: 1,
            page: 1
          });
        }
      }
    }
  };

  const sortName = async (type) => {

    if(props.cartType && props.cartType === 'express') {
      let filteredProducts = {brandIdList: [], categorySelected: [], subCategorySelected: [], outOfStock: 0, search: '', sort: ''};
      if(!Array.isArray(props.filteredProducts) && Object.keys(props.filteredProducts).length) {
        filteredProducts.brandIdList = props.filteredProducts.brandIdList;
        filteredProducts.categorySelected = props.filteredProducts.categorySelected;
        filteredProducts.subCategorySelected = props.filteredProducts.subCategorySelected;
        filteredProducts.search = props.filteredProducts.search;

        if(textSearch !== '' && window.location.pathname.includes('/express/store')) {
          filteredProducts.search = textSearch;
        }
      }

      let itemsStore = {};
      let sortBy = type === 1 ? 'a-z' : 'z-a';
      setSort(sortBy);

      if(history.location.pathname.includes('/express/search')) {
        itemsStore = await expressService.searchItems(
          [storeId],
          brandId,
          filteredProducts.categorySelected,
          filteredProducts.subCategorySelected,
          1,
          filteredProducts.search,
          sortBy
        );
      }
      else {
        itemsStore = await expressService.storeItems(
          [storeId],
          brandId,
          filteredProducts.categorySelected,
          filteredProducts.subCategorySelected,
          1,
          filteredProducts.search,
          sortBy
        );
      }

      // Remove label of Extra item of multi store
      const extraDataLabel = document.querySelector('.clearFlex');
      if(extraDataLabel) {
        extraDataLabel.remove();
      }
      if(Object.keys(itemsStore).length) {
        props.initProductExpressStore(itemsStore.list);
      }
      props.sortProducts(filteredProducts);
    }
    else {
      props.getSortProductsName(type, props.products);
    }
    setFilterShow((pre) => !pre);
  };
  const sortPrice = async (type) => {
    if(props.cartType && props.cartType === 'express') {
      let filteredProducts = {brandIdList: [], categorySelected: [], subCategorySelected: [], outOfStock: 0, search: '', sort: ''};
      if(!Array.isArray(props.filteredProducts) && Object.keys(props.filteredProducts).length) {
        filteredProducts.brandIdList = props.filteredProducts.brandIdList;
        filteredProducts.categorySelected = props.filteredProducts.categorySelected;
        filteredProducts.subCategorySelected = props.filteredProducts.subCategorySelected;
        filteredProducts.search = props.filteredProducts.search;
        filteredProducts.sort = props.filteredProducts.sort;

        if(textSearch !== '' && window.location.pathname.includes('/express/store')) {
          filteredProducts.search = textSearch;
        }
      }
      let itemsStore = {};
      let sortBy = type === 3 ? 'low-high' : 'high-low';
      setSort(sortBy);
      if(history.location.pathname.includes('/express/search')) {
        itemsStore = await expressService.searchItems(
          [storeId],
          filteredProducts.brandIdList,
          filteredProducts.categorySelected,
          filteredProducts.subCategorySelected,
          1,
          filteredProducts.search,
          sortBy
        );
      }
      else {
        itemsStore = await expressService.storeItems(
          [storeId],
          filteredProducts.brandIdList,
          filteredProducts.categorySelected,
          filteredProducts.subCategorySelected,
          1,
          filteredProducts.search,
          sortBy
        );
      }

      // Remove label of Extra item of multi store
      const extraDataLabel = document.querySelector('.clearFlex');
      if(extraDataLabel) {
        extraDataLabel.remove();
      }

      props.initProductExpressStore(itemsStore.list);
      props.sortProducts(filteredProducts);
    }
    else {
      props.getSortProductsPrice(type, props.products);
    }
    setFilterShow((pre) => !pre);
  };

  const sortByNameProduct = (e) => {
    props.sortByNameProduct(e.target.value, props.products);
  };

  const sortItems = [
    { name: t('shop_item_sort_by_name_asc_title', false), onClick: () => sortName(1) },
    { name: t('shop_item_sort_by_name_desc_title', false), onClick: () => sortName(2) },
    { name: t('shop_item_sort_by_price_low_to_high_title'), onClick: () => sortPrice(3) },
    { name: t('shop_item_sort_by_price_high_to_low_title'), onClick: () => sortPrice(4) },
  ];

  const [isFetching, setIsFetching] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setIsFetching(false);
    },2600)
  },[]);
  if (props.category.length > 0 && props.products.length === 0 && window.location.pathname.split("/").indexOf("search") >= 0 && props.loading === false && !isFetching) {
    return (
      <NoResultFound
        props={props}
        toggleFilter={toggleFilter}
        isFilterModal={isFilterModal}
        isBrandFilter={isBrandFilter}
        setSelectedBrands={setSelectedBrands}
        GetSub={GetSub}
      />
    );
  }

  // const setSelectedBrands = async (values = selected) => {
  //   setFilterShow(false);
  //   let b = values.map((el) => {
  //     return el.value;
  //   });
  //   setBValues(b);
  //   setItemCategory(b);
  //   if(props.cartType && props.cartType === 'express') {
  //     let filteredProducts = {brandIdList: [], categorySelected: [], subCategorySelected: [], outOfStock: 0, search: '', sort: ''};
  //     filteredProducts.brandIdList = b;
  //     if(!Array.isArray(props.filteredProducts) && Object.keys(props.filteredProducts).length) {
  //       filteredProducts.categorySelected = props.filteredProducts.categorySelected;
  //       filteredProducts.subCategorySelected = props.filteredProducts.subCategorySelected;
  //       filteredProducts.search = props.filteredProducts.search;
  //       filteredProducts.sort = props.filteredProducts.sort;
  //     }

  //     const itemsList = await expressService.storeItems(
  //       [storeId],
  //       b,
  //       filteredProducts.categorySelected,
  //       filteredProducts.subCategorySelected,
  //       isOutOfStock,
  //       filteredProducts.search,
  //       sort
  //     );

  //     if(itemsList.list.length) {
  //       setBrandId(b);
  //       props.initProductExpressStore(itemsList.list);
  //       props.sortProducts(filteredProducts);
  //     }
  //     else {
  //       setShowFilterNotFound(true)
  //     }
  //   }
  //   else {
  //     props.getProductFilterBrands(
  //       values,
  //       props.products,
  //       props.allproducts,
  //       SUB_CAT_ID,
  //       localStorage.getItem("cat_id"),
  //       props.oos,
  //       state.text,
  //     );
  //   }
  // };

	async function setSelectedBrands(values = selected, catValues = selectedCat, SubCatValues = selectedSubCat, countries = [], min = 0, max = 1000, is_filter = isFilter, priority = 0, promotion = false, sort, check = check, dietarySelected = dietarySelected) {
    setFilterShow(false)
    localStorage.setItem('isfilter',true);
    if (!!(Params && search) && window.location.pathname.split("/")[1] === "search") {
      localStorage.setItem("sub_cat_id", -1);
      localStorage.setItem("subcatname", "");
      localStorage.setItem("mode", "search");
    }
    let b = values.map((el) => {
      return el.value;
    });

    let c = catValues.map((el) => {
      return el.value;
    });
    let sub = SubCatValues.map((el) => {
      return el.value;
    })
    let allSelected = [];
    allSelected.brands = values;
    allSelected.category = catValues;
    allSelected.sub_category = SubCatValues;
    allSelected.min = min;
    allSelected.max = max;
    allSelected.isFilter = is_filter;  
    allSelected.priority = priority ? 1 : 0;
    allSelected.promotion = promotion;
    allSelected.sort = sort;
    allSelected.check = check;
		allSelected.country_id = countries.map((country) => country.value);
		allSelected.diet_id = dietarySelected.map((diet) => diet.value);
		allSelected.dietary = dietarySelected;
    setBValues(b)
    setItemCategory(b)
    setCatValues(c);
		setSubCatValues(sub);
    setAllCategory(c);
    if (props.cartType && props.cartType === 'express') {
	    let filteredProducts = {
		    brandIdList: [],
		    categorySelected: [],
		    subCategorySelected: [],
		    outOfStock: 0,
		    search: '',
		    sort: '',
		    dietarySelected: []
	    };
      filteredProducts.brandIdList = b;
      if(!Array.isArray(props.filteredProducts) && Object.keys(props.filteredProducts).length) {
        filteredProducts.categorySelected = props.filteredProducts.categorySelected;
	      filteredProducts.subCategorySelected = props.filteredProducts.subCategorySelected;
	      filteredProducts.dietarySelected = props.filteredProducts.dietarySelected;
        filteredProducts.search = props.filteredProducts.search;
        filteredProducts.sort = props.filteredProducts.sort;
      }

      const itemsList = await expressService.storeItems(
        [storeId],
        b,
        filteredProducts.categorySelected,
	      filteredProducts.subCategorySelected,
	      filteredProducts.dietarySelected,
        isOutOfStock,
        filteredProducts.search,
        sort
      );

      if (itemsList.list.length) {
        setCatId(b);
        props.initProductExpressStore(itemsList.list);
        props.sortProducts(filteredProducts);
      }
      else {
        setShowFilterNotFound(true)
      }
    }
    else {
      props.getProductFilterBrands(
        allSelected,
        props.products,
        props.allproducts,
        ["search"].includes(window.location.pathname.split('/')[1]) ? -1 : SUB_CAT_ID,
        localStorage.getItem("cat_id"),
        brandName,
        props.oos,
        state.text,
      );
    }
    if(allSelected.category && allSelected.category.cat_id.length > 0) {
      Params.set('cat_id', allSelected.category?.cat_id);
    }else {
      Params.delete('cat_id');
    }
    if(allSelected.sub_category && allSelected.sub_category.sub_cat_id.length > 0) {
      Params.set('sub_cat_id', allSelected.sub_category?.sub_cat_id);
    }else {
      Params.delete('sub_cat_id')
    }
    if(allSelected.brands && allSelected.brands?.brand_id.length > 0) {
      Params.set('brand_id', allSelected.brands?.brand_id);
    }else {
      Params.delete('brand_id')
    }

		if (allSelected.dietary && allSelected.dietary?.diet_id.length > 0) {
			Params.set('diet_id', allSelected.dietary?.diet_id);
		} else {
			Params.delete('diet_id')
		}

    if(allSelected.check && allSelected.check == true){
      Params.set('oos', allSelected.check);
    }else{
      Params.delete('oos')
    }

    if(allSelected.min && allSelected.min > 0){
      Params.set('min', allSelected.min);
    }else {
      Params.delete('min')
    }

    if(allSelected.max && allSelected.max < 1000){
      Params.set('max', allSelected.max);
    }else {
      Params.delete('max')
    }
    // Params.set('isFilter', true);
    if(allSelected.priority == true){
      Params.set('priority', allSelected.priority);
    }else {
      Params.delete('priority')
    }

    if(allSelected.promotion == true){
      Params.set('promotion', allSelected.promotion);
    }else {
      Params.delete('promotion')
    }

    if(allSelected.sort && allSelected.sort != "undefined" && allSelected.sort != "null"){
      Params.set('sort', allSelected.sort && allSelected.sort != "undefined" && allSelected.sort != "null" ? allSelected.sort : "");
    }else {
      Params.delete('sort')
    }
    if(allSelected.country_id && allSelected.country_id.length > 0){
      Params.set('country_id', allSelected.country_id);
    }else {
      Params.delete('country_id')
    }
    // Set or update the 'oos' parameter
    // Params.set('oos', 1);
    const newUrl = `${window.location.pathname}?${Params.toString()}`;
    
    // Replace the current URL with the new one, no page refresh
    history.replace(newUrl);

  };

  const handleSelection = (item) => {
    const isBrandPresent =
      selected && selected.length
        ? selected.find((brand, index) => brand.value === item.value)
        : null;
    // const isCategoryPresent = selectedCat && selectedCat.length 
    //     ? selectedCat.find((category, index) => category.value === item.value)
    //     : null;
    //brand
    if (!isBrandPresent) {
      setBrandSelected((pre) => ({ ...pre, [`${item.value}`]: true }));
      setSelected((pre) => {
        let a = pre;
        a.push(item);
        return a;
      });
    } else {
      const newArr = selected.filter((brand) => brand.value !== item.value);
      setBrandSelected((pre) => {
        delete pre[`${item.value}`];
        return pre;
      });
      setSelected(newArr);
    }
    //cat
    // if (!isCategoryPresent) {
    //   setCatSelected((pre) => ({ ...pre, [`${item.value}`]: true }));
    //   setSelectedCat((pre) => {
    //     let a = pre;
    //     a.push(item);
    //     return a;
    //   });
    // } else {
    //   const newArr = selected.filter((cat) => cat.value !== item.value);
    //   setCatSelected((pre) => {
    //     delete pre[`${item.value}`];
    //     return pre;
    //   });
    //   setSelectedCat(newArr);
    // }
  };
  const clearAllBrand = () => {
    setBrandSelected({});
    setSelected([]);
  };

  const getbrandimage = (name) => {
    var b = props.brands.filter(elem => {
      return elem.name === name   
    });
    return b.length !== 0
			? b[0].image
				? b[0].image
				: defaultBrandLogo
			: defaultBrandLogo;
  };

  const PrevButton = ({ onClick, children }) => {
    return (
      <Prev
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
        className="prevButton"
      >
        {children}
      </Prev>
    );
  };
  const NextButton = ({ onClick, children }) => {
    return (
      <Next
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
        className="nextButton"
      >
        {children}
      </Next>
    );
  };
  
  const ButtonGroup = ({ next, previous }) => {
    return (
      <Wrapper>
        <>
          <PrevButton onClick={() => previous()}>
            <ArrowPrev />
          </PrevButton>
          <NextButton onClick={() => next()}>
            <ArrowNext />
          </NextButton>
        </>
  
        {/* if prop isRtl true swap prev and next btn */}
      </Wrapper>
    );
  };

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  let modalClasses = `modal ${isFilterModal ? 'show animate' : ''}`;
  let bgBlur = `bg_blur ${isFilterModal ? 'show' : ''}`;

  const searchCategory = () => {
    if (props.products.length > 0) {
      let cat_id =
        window.location.pathname === "/" ? 18 : props.products[0].cat_id;

      if (!((cats).includes(window.location.pathname.split("/")[1]) && window.location.pathname.split("/").length === 2) || !(window.location.pathname.split("/")[1] === "search") || !(window.location.pathname.split("/")[1] === "brand")){
        // localStorage.setItem("sub_cat_id", SUB_CAT_ID);
      }
    
      let cat_data = null;
      let cat_name = null;
      let sub_cat_name = null;
      if (window.location.pathname.split("/")[1] !== "search" && window.location.pathname.split("/")[1] !== "brand"){
        props.category.map((element, index) => {
          if (element.cat_id == cat_id) {
            cat_data = element;
            cat_name = element.name;
          } else {
            
          }
        });
      }

      return (
        <div>
          {window.location.pathname.split("/")[1] === "brand" ? 
          <>
              {/* <SidebarFilter
                brands={props.filterBrands}
                products={props.products}
                setSelectedBrands={setSelectedBrands}
                // setSelectedCategory={setSelectedCategory}
                isModal={isBrandFilter}
                ModalOpen={onOpen}
                ModalClose={onClose}
              /> */}
          <BrandImageWrapper>
          <LazyLoad height={70}>
          <img
              src={getbrandimage(brandname)}
              className="brand-image"
              // style={{ height: "80%", width: "auto", maxHeight: "100%" }}
              alt={brandname}
              onError={(e)=>{
                e.target.onerror = null;
                e.target.src = defaultBrandLogo;
              }}
              // onLoad={() => setLoaded(true)}
              // onLoad={()=> {return <Loader />}}
            />
            </LazyLoad>
          </BrandImageWrapper>
          <BrandInfo>
            {brandinfo}
          </BrandInfo>
          </> : null}
          {window.location.pathname.split("/")[1] === "search" ? <span style={{fontWeight: "700"}}>{ t('shop_current_location_search_result_label') }</span> : null}
        </div>
      );
    } else {
      return (
        <div>
          {/* <SidebarFilter
            GetSub={GetSub}
            brands={props.filterBrands}
            products={props.products}
            setSelectedBrands={setSelectedBrands} 
            // setSelectedCategory={setSelectedCategory}
            isModal={isBrandFilter}
            ModalOpen={onOpen}
            ModalClose={onClose}
          /> */}
          {window.location.pathname.split("/")[1] === "brand" ? <div style={{fontWeight: "500" , margin: "10px 0 10px 0"}}>{brandinfo}</div> : null}
          {window.location.pathname.split("/")[1] === "search" ? <span style={{fontWeight: "700"}}>{ t('shop_current_location_search_result_label') }</span> : null}
        </div>
      );
    }                                                                                                                    
  };
  return (
    <div className="d-block">
      <FilterWrapper>
        {/* <div className="row" style={{ marginBottom: "15px", width: "100%" }}>
          <div className="col-sm-12" style={{ alignSelf: "center", width: "100%" }}>
            {searchCategory()}
          </div>
        </div> */}
        <div className={bgBlur} onClick={() => toggleFilter()} ></div>
        <FilterDiv >
          <div className={`${modalClasses} row`}>
            {/* {window.screen.width >= 700 && props.cartType !== 'express' ? (
              <div className="col-sm-two">
                { window.location.pathname.split("/")[1] !== "search" && window.location.pathname.split("/")[1] !== "brand" && <label>
                  <span style={{marginTop: "5px"}}>{ t('shop_item_show_out_of_stock_option_title') }</span>
                  <Switch className={`react-switch ${!!checked ? 'active' : ''}`} onClick={toggleCheckbox} onChange={toggleCheckbox} checked={ !!checked } />
                </label>}
              </div>
            ) : null} */}
            {props.cartType !== 'express' ? (
              <div style={{ padding: "0px" }} className="col-sm-eight">
                {/* <BrandFilter
                  brands={props.filterBrands}
                  setSelectedBrands={setSelectedBrands}
                  isModal={isBrandFilter}
                  ModalOpen={onOpen}
                  ModalClose={onClose}
                /> */}
                <SidebarFilter 
                  brands={props.filterBrands}
                  GetSub={GetSub}
                  products={props.products}
                  setSelectedBrands={setSelectedBrands}
                  // setSelectedCategory={setSelectedCategory}
                  isModal={isBrandFilter}
                  ModalOpen={isFilterModal}
                  showModal={toggleFilter} 
                  loading={props.loading}
                  query={queryFilter}
                  // className={modalClasses}
                />
              </div>
            ) : window.screen.width < 700 && props.cartType !== 'express' ? (
              // <BrandFilter
              //   brands={props.filterBrands}
              //   setSelectedBrands={setSelectedBrands}
              //   isModal={isBrandFilter}
              //   ModalOpen={onOpen}
              //   ModalClose={onClose}
              // />
                <SidebarFilter
                  brands={props.filterBrands}
                  GetSub={GetSub}
                  products={props.products}
                  setSelectedBrands={setSelectedBrands}
                  // setSelectedCategory={setSelectedCategory}
                  isModal={isBrandFilter}
                  ModalOpen={isFilterModal}
                  showModal={toggleFilter} 
                  loading={props.loading}
                  query={queryFilter}
                  // className={modalClasses}
                />
            ) : props.cartType !== 'express' ? <div className="_1q59bef"></div> : null
            }
            {/* <div className={`col-sm-two sort-filter-hide ${props.cartType}`}>
              <DropDown title={ t('shop_item_sort_title', false) } items={sortItems} />
            </div> */}

            {/* {props.cartType !== 'express'
              ? <>
                <div className="_1q59bef"></div>
                <div className="col-sm-two sort-name-filter">
                  <input
                    type="text"
                    style={{
                      borderColor: "rgb(176, 176, 176) !important",
                      padding: "4px 10px",
                      width: "120px",
                      borderRadius: "20px",
                      borderWidth: "1px",
                      borderTopColor: "rgb(176, 176, 176) !important",
                      background: "white",

                      borderStyle: "double",
                      outline: "none",
                    }}
                    placeholder={ t('shop_item_filter_placeholder', false) }
                    value={props.search_text}
                    name="type to filter"
                    onChange={(e) => sortByNameProduct(e)}
                  />
                </div>
              </>
              : null
            } */}
          </div>
        </FilterDiv>
        {/* {bannerPickers()} */}
      </FilterWrapper>

      {props.cartType !== 'express' ? 
      <ProductTopTitle>
        {window.location.pathname.split("/")[1] == "search" ? "Search results" : "Products In Category"}
      </ProductTopTitle>
      : null
      }
      {<ProductsRow id={"productList"} className={props.cartType === "express" ? "ex_top" : null}>
        {props.FilteredNameProducts == false
          ? props.products.length
            ? props.products.map((item, index) =>
              <ProductsCol key={index}
                id={typeof item.isExtraIndex !== 'undefined' && item.isExtraIndex === 0 ? `isExtraData` : null }
                data-id={item.item_id}
                ref={el => itemsRefs.current[item.item_id] = el}
              >
                <ProductCard
                  title={item.name}
                  description={item.about_item}
                  image={item.default_image_url}
                  weight={
                    item.store_items_price_types[0].name !== " "
                      ? item.store_items_price_types[0].name
                      : item.store_items_price_types[0].weight +
                      " " +
                      item.store_items_price_types[0].weight_unit
                  }
                  outOfStock={
                    !item.store_items_price_types[0].available_quantity
                  }
                  isAvailable={item.store_items_price_types[0].is_available}
                  currency={CURRENCY}
                  price={item.store_items_price_types[0].mrp}
                  salePrice={item.store_items_price_types[0].price}
                  isSameDay={item.same_day}
                  discountInPercent={item.discountInPercent}
                  data={item}
                  deviceType={deviceType}
                  onClick={() => {
                    if(props.cartType === "express"){
                      logPageView(`/product/${item.item_ref_id}`)
	                    logViewItem(item)
                      handleQuickViewModal(item, deviceType, index)
                    } else {
                      logPageView(`/product/${item.item_ref_id}`)
	                    logViewItem(item)
                      history.push(`/product/${item.item_ref_id}`);
                      window.scrollTo(0, 0)
                    }
                  }}
                  onCartClick={() => {
                    document.getElementById("joinBTn").click();
                    window.trigger = "add to cart"
                  }}
                  onUpdate={(quantity) => {
                    updateItem(item,quantity);
                  }}
                  promo={item.promo ? 1 : 0}
                  promoPrice={item.promo ? item.promo_price : null}
                  promoStartDate={item.promo ? item.promo_start_date : null}
                  promoEndDate={item.promo ? item.promo_end_date : null}
                  brandId={item.brand_id === 0 || item.brand_id === null ? 0 : item.brand_id}
                  brands={props.brands}
                  loading={props.loading}
                  page={props.page}
                  productCode={item.product_code}
                  isCloseSEO={isCloseSEO}
                />
              </ProductsCol>
            )
            : props.loading || isFetching
            ? <Spinner animation="border" style={{ color: "#9cc54b"}} />
            : <p>{ t('error_product_not_found') }</p>
          : null
        }
        {props.FilteredNameProducts == true &&
          props.filteredProducts.map((item, index) => (
            <ProductsCol key={index}>
              <ProductCardWrapper>
                <ProductCard
                  title={item.name}
                  description={item.about_item}
                  image={item.default_image_url}
                  weight={
                    item.store_items_price_types[0].name !== " "
                      ? item.store_items_price_types[0].name
                      : item.store_items_price_types[0].weight +
                        " " +
                        item.store_items_price_types[0].weight_unit
                  }
                  outOfStock={
                    !item.store_items_price_types[0].available_quantity
                  }
                  // weight={item.store_items_price_types[0].name}
                  currency={CURRENCY}
                  price={item.store_items_price_types[0].mrp}
                  salePrice={item.store_items_price_types[0].price}
                  isSameDay={item.same_day}
                  discountInPercent={item.discountInPercent}
                  data={item}
                  deviceType={deviceType}
                  onClick={() => {
                    if (props.cartType === "express") {
                      logPageView(`/product/${item.item_ref_id}`)
	                    logViewItem(item)
                      handleQuickViewModal(item, deviceType, index)
                    } else {
                      logPageView(`/product/${item.item_ref_id}`)
	                    logViewItem(item)
                      history.push(`/product/${item.item_ref_id}`);
                      window.scrollTo(0, 0)
                    }
                  }}
                  onCartClick={() => {
                    document.getElementById("joinBTn").click();
                    window.trigger = "add to cart"
                  }}
                  promo={item.promo ? 1 : 0}
                  promoPrice={item.promo ? item.promo_price : null}
                  promoStartDate={item.promo ? item.promo_start_date : null}
                  promoEndDate={item.promo ? item.promo_end_date : null}
                  brandId={item.brand_id === 0 || item.brand_id === null ? 0 : item.brand_id}
                  brands={props.brands}
                  loading={props.loading}
                  page={props.page}
                  productCode={item.product_code}
                  isExtra={isExtra}
                  isCloseSEO={isCloseSEO}
                />
                {/* </Fade> */}
              </ProductCardWrapper>
            </ProductsCol>
          ))}
      </ProductsRow>}

      {props.isHasMore && props.products.length !== 0 &&
        <center>
          <Button
            // onClick={() => {const body = { page: props.page + 1}; props.changePage(body); setLoader(false);}}
            onClick={() => handleLoadmore()}
            type="button"
            disabled={props.loading}
            title={ t('common_show_more_label', false) }
            size='small'
            intlButtonId="proceesCheckout"
            loader={<Loader />}
            isLoading={props.loading || loader}
            id={"showMore"}
            style={{display: props.loading || loader ? "block" : "none", backgroundColor: "#E6E6E6"}}
          />
        </center>
      }
      
      {show && (
        <QuickView
          show={show}
          onHide={onHide}
          props={props}
          deviceType={deviceType}
          onCartClick={() => {
            handleJoin();
            window.trigger = "add to cart"
          }}
        />
      )}
      <Modal
        show={showform}
        onHide={() => setShowForm(false)}
        dialogClassName="modal-90w authModal"
        aria-labelledby="example-custom-modal-styling-title"
        backdrop="static"
      >
        <Modal.Header closeButton style={{ border: 0 }}></Modal.Header>
        <Modal.Body style={{ padding: 0 }}>
          <AuthenticationForm />
        </Modal.Body>
      </Modal>
      <Modal
        show={isBrandFilter}
        onHide={onClose}
        // dialogClassName="modal-lg"
        aria-labelledby="example-custom-modal-styling-title"
        size="lg"
        animation={true}
        centered
      >
        <Modal.Header closeButton style={{ padding: ".4rem 1rem" }}>
          {/* <Modal.Title>Filters</Modal.Title> */}
        </Modal.Header>
        <Modal.Body style={{ padding: 0 }}>
          <FilterModalWrapper>
            {/* <div style={{ padding: "8px", display: "flex", flexWrap: "wrap" }}>
              {props.filterBrands &&
                props.filterBrands.brand.map((item, index) => (
                  <BrandButton 
                    key={index}
                    style={
                      isBrandSelected &&
                      isBrandSelected[`${item.value}`] !== undefined
                        ? {
                            backgroundColor: "#f2f2f2",
                            color: "#000",
                            marginBottom: "4px",
                          }
                        : { marginBottom: "4px" }
                    }
                    onClick={() => handleSelection(item)}
                  >
                    <span style={{ whiteSpace: "nowrap" }} className="_36rlri">
                      {" "}
                      {item.label}
                    </span>
                    <span className="_1lz9hno">
                      <span className="_a7a5sx">
                        {isBrandSelected &&
                        isBrandSelected[`${item.value}`] === undefined ? (
                          <svg
                            aria-hidden="true"
                            role="presentation"
                            focusable="false"
                            viewBox="0 0 32 32"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              display: "block",
                              fill: "none",
                              height: "12px",
                              width: "12px",
                              stroke: "currentcolor",
                              strokeWidth: "5.33333",
                              overflow: "visible",
                            }}
                          >
                            <path d="m2 16h28m-14-14v28"></path>
                          </svg>
                        ) : (
                          <svg
                            aria-hidden="true"
                            role="presentation"
                            focusable="false"
                            viewBox="0 0 32 32"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              display: "block",
                              fill: "none",
                              height: "12px",
                              width: "12px",
                              stroke: "currentcolor",
                              strokeWidth: "5.33333",
                              overflow: "visible",
                            }}
                          >
                            <path fill="none" d="m4 16.5 8 8 16-16"></path>
                          </svg>
                        )}
                      </span>
                    </span>
                  </BrandButton>
                ))}
              {window.screen.width < 700 ? (
                <div className="col-sm-2">
                  <BrandButton
                    style={{
                      marginTop: "15px",
                      marginBottom: "10px",
                      whiteSpace: "nowrap",
                      marginLeft: window.screen.width <= 500 ? "0" : "auto",
                      marginRight: window.screen.width <= 500 ? "auto" : "0",
                      ...(checked
                        ? { background: "#f2f2f2", color: "#000" }
                        : {}),
                    }}
                    onClick={() => toggleCheckbox()}
                  >
                    { window.location.pathname.split("/")[1] !== "search" && window.location.pathname.split("/")[1] !== "brand" && <label>
                    <span style={{marginTop: "5px"}}>{ t('shop_item_show_out_of_stock_option_title') }</span>
                    <Switch className="react-switch" onClick={toggleCheckbox} onChange={toggleCheckbox} checked={!!checked} />
                    </label>}
                  </BrandButton>
                </div>
              ) : null}
            </div> */}
            <div className="_pwbsgx">
              <div className="_1qbrhv4">
                <button
                  onClick={clearAllBrand}
                  disabled={
                    isBrandSelected && Object.keys(isBrandSelected).length
                      ? false
                      : true
                  }
                  type="button"
                  className="_gby1jkw"
                >
                  { t('shop_item_filter_clear_button') }
                </button>
                <div className="_ls0e43">
                  <button
                    onClick={() => setSelectedBrands()}
                    type="button"
                    className="_ajuxzjo"
                  >
                    { t('shop_item_filter_save_button') }
                  </button>
                </div>
              </div>
            </div>
          </FilterModalWrapper>
        </Modal.Body>
      </Modal>

      <Modal show={showFilterNotFound} onHide={() => setShowFilterNotFound(false)} centered>
        <Modal.Body className="text-center">
          <ErrorModal>
            <p>{ t('common_no_products_found_label') }</p>
            <Button size='sm btn-sm'
                    title={ t('button_close_label') }
                    className="cancelBtn express"
                    variant="success"
                    onClick={() => setShowFilterNotFound(false)}
            />
          </ErrorModal>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default Products;
